import { createSelector } from '@reduxjs/toolkit';
import fastDeepEqual from 'fast-deep-equal/es6';

import { LoyaltySecondaryIdentifierType } from 'generated/graphql-gateway';
import { RootState } from 'state/global-state/store';

// For more complex multiline selectors, export from this file
export const selectUser = ({ loyalty }: RootState) => loyalty.user.loyaltyUser;

export const selectLoyaltyLoading = ({ loyalty }: RootState) => loyalty.user.loyaltyLoading;

export const selectLoyaltyUser = createSelector(
  [selectUser, selectLoyaltyLoading],
  (loyaltyUser, loyaltyLoading) => ({
    loyaltyUser: loyaltyUser ?? null,
    loading: loyaltyLoading,
  }),
  {
    memoizeOptions: {
      resultEqualityCheck: fastDeepEqual,
    },
  }
);

export const select12DigitSwipeCard = createSelector(
  ({ loyalty }: RootState) => loyalty.user?.loyaltyUser?.secondaryIdentifiers,
  secondaryIdentifiers =>
    secondaryIdentifiers?.find(
      identifier =>
        identifier?.identifierType === LoyaltySecondaryIdentifierType.LOYALTY12DIGITSWIPECARD
    )
);
